import { HostingDisplayName } from '@atlassian/mpac-types';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
import { ExternalLink, SectionHeading, UserGeneratedHtml } from '@atlassian/mpac-ui';
import { DateUtils, PaymentModelUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { TEST_ID } from '../../../../constants';
import { Section, SectionSubHeading, SectionsWrapper, TwoColumns } from '../../../Section';
import { BulletSpan, ReleaseNotesUGC, ResourcesList } from './styles';
import { getCompatibleVersionsSummary } from './utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export const Bullet = () => /*#__PURE__*/_jsx(BulletSpan, {
  children: "\u2022"
});

// eslint-disable-next-line complexity, max-lines-per-function
const VersionsTab = props => {
  const hasReleaseNotesUrl = !!props.releaseNotesUrl;
  const hasMultipleVersions = props.hosting !== AtlassianProductHostingType.Cloud && props.versionCount > 1; // Cloud has only one semantic version

  const hasAdditionalResources = hasReleaseNotesUrl || hasMultipleVersions;
  return /*#__PURE__*/_jsx(SectionsWrapper, {
    children: /*#__PURE__*/_jsxs(TwoColumns, {
      children: [/*#__PURE__*/_jsx(TwoColumns.Left, {
        children: /*#__PURE__*/_jsxs(Section, {
          "data-testid": TEST_ID.VERSION_SECTION,
          children: [/*#__PURE__*/_jsx(SectionHeading, {
            children: "Versions"
          }), props.hosting !== AtlassianProductHostingType.Cloud && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsxs("span", {
              children: ["Version ", props.version]
            }), /*#__PURE__*/_jsx(Bullet, {})]
          }), getCompatibleVersionsSummary({
            hosting: props.hosting,
            productCompatibilities: props.productCompatibilities
          }), /*#__PURE__*/_jsxs("p", {
            children: ["Released: ", DateUtils.longDate(props.releaseDate)]
          }), props.releaseSummary && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(SectionSubHeading, {
              children: "Summary"
            }), /*#__PURE__*/_jsx("p", {
              children: props.releaseSummary
            })]
          }), props.releaseNotes && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(SectionSubHeading, {
              children: "Details"
            }), /*#__PURE__*/_jsx(ReleaseNotesUGC, {
              children: /*#__PURE__*/_jsx(UserGeneratedHtml, {
                dangerousHtml: props.releaseNotes
              })
            })]
          }), props.hosting === AtlassianProductHostingType.Cloud && props.paymentModel && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(SectionSubHeading, {
              children: "Payment model"
            }), /*#__PURE__*/_jsx("p", {
              children: PaymentModelUtils.mapPaymentModelToDisplayValue(props.paymentModel)
            })]
          }), props.hosting === AtlassianProductHostingType.Cloud && props.licenseType && /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(SectionSubHeading, {
              children: "License type"
            }), /*#__PURE__*/_jsx("p", {
              children: props.licenseType
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(TwoColumns.Right, {
        children: /*#__PURE__*/_jsxs(Section, {
          "data-testid": TEST_ID.RESOURCE_SECTION,
          children: [/*#__PURE__*/_jsx(SectionHeading, {
            children: "Resources"
          }), /*#__PURE__*/_jsxs(ResourcesList, {
            children: [props.releaseNotesUrl && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(ExternalLink, {
                href: props.releaseNotesUrl,
                children: "See full release notes"
              })
            }), hasMultipleVersions && props.hosting !== AtlassianProductHostingType.Cloud && /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsxs("a", {
                href: props.versionHistoryUrl,
                children: ["See all ", props.versionCount, " ", HostingDisplayName[props.hosting], " versions"]
              })
            }), !hasAdditionalResources && /*#__PURE__*/_jsx("li", {
              children: "There are no additional resources."
            })]
          })]
        })
      })]
    })
  });
};
export default VersionsTab;